export default __webpack_public_path__ + "static/media/VE.38c522da.svg";